export default __webpack_public_path__ + "static/media/photo12.196caa58.jpg";